import { NuveiTransactionStatus } from "app/utils/const";
import { useEffect, useState } from "react";

const TransactionStatusComponent = ({ transactionStatus }) => {
  const [statusClassName, setStatusClassName] = useState("");

  const statusClassMap = {
    APPROVED: NuveiTransactionStatus.SUCCESS,
    SUCCESS: NuveiTransactionStatus.SUCCESS,
    DECLINED: NuveiTransactionStatus.DECLINED,
    ERROR: NuveiTransactionStatus.ERROR,
    PENDING: NuveiTransactionStatus.PENDING,
  };

  useEffect(() => {
    setStatusClassName(
      `transaction-status ${
        statusClassMap[transactionStatus]?.toLowerCase() || ""
      }`
    );
  }, [transactionStatus]);

  return <div className={statusClassName}>{transactionStatus}</div>;
};

export default TransactionStatusComponent;
